<template>
    <Paper id="mipIframe">
        <div>
            <el-button style="margin-bottom:12px;" size="mini" class="el-button" type="primary" @click="submitMip" :loading="btnloading">mip提交</el-button>
        </div>
        <iframe class="ifr" id="myIFrame" :src="mipurl" />
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import lsrmapi from '../../../api/contract/warningTask';
import { mapGetters } from 'vuex';
const TIMESET = 1500;
export default {
    components: { Paper },
    data() {
        return {
            btnloading: false,
            mipurl: '',
            fdStatus: ''
        };
    },
    mounted() {
        window.addEventListener('message', this.messageFunc, false);
        this.queryOneInstanceFn();
    },
    destroyed() {
        window.removeEventListener('message', this.messageFunc, false);
    },
    methods: {
        messageFunc() {
            this.messageCallback(event);
        },
        submitMip() {
            const myWindow = document.getElementById('myIFrame').contentWindow;
            myWindow.postMessage('mbpm_getApprovalData', '*');
        },
        queryOneInstanceFn() {
            lsrmapi.queryOneInstance({ contractCode: this.$route.query.formInstanceId }).then(res => {
                this.pubulishMipFlag = false;
                if (res && +res.code === 0) {
                    this.fdStatus = res.data.auditStatus;
                    // this.mipurl = res.data.extFrameUrl;
                    this.mipurl = `${res.data.extFrameUrl}&userCode=${this.user.userCode}&userName=${this.user.userName}`;
                }
            });
        },
        messageCallback(event) {
            if (event.data && event.data.data && event.data.success) {
                const params = event.data.data;
                params.tenantCode = this.currentTenant.tenantCode;
                params.currentApplicationCode = this.applicationCode;
                params.formInstanceId = this.$route.query.formInstanceId;
                lsrmapi.createProcess(params).then(res => {
                    if (+res.code === 0) {
                        this.btnloading = true;
                        setTimeout(() => {
                            this.btnloading = false;
                            this.$router.push(this.$route.query.path);
                        }, TIMESET);
                    }
                });
            }
        }
    },
    computed: {
        ...mapGetters(['currentTenant', 'applicationCode', 'user'])
    }
};
</script>

<style>
.ifr {
    min-width: 1121px;
    min-height: 570px;
    border: none;
    width: 100%;
}
</style>